import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import PF2MTooltip from '~/components/PF2MTooltip';
import EquipmentGroupList from '../EquipmentGroupList';
import styles from './styles';

const EquipmentTypeList = memo(({
  list,
  isFullScreenActive,
  highlightedEquipments,
  classes,
}) => {
  const { t: translate } = useTranslation();

  if (list && list?.length === 0) {
    return (
      <div className={classes.wrapperEmptyState}>
        <div className={classes.labelEmptyState}>
          {translate('common:NoAvailableData')}
        </div>
      </div>
    );
  }
  return (
    <div className={classes.containerWrapper}>
      {list.map(type => (
        <div className={classes.containerType} key={type?.equip_type}>
          <div className={classes.wrapperLabelType}>
            <div className={classes.boxLabelType}>
              <PF2MTooltip
                title={type?.label}
                PopperProps={{
                  container: isFullScreenActive && document.fullscreenElement
                    ? document.fullscreenElement
                    : document.body,
                }}
              >
                <span className={classes.labelType}>{type?.label || ''}</span>
              </PF2MTooltip>
            </div>
          </div>
          <EquipmentGroupList
            key={type.equip_type}
            list={type.list || []}
            isFullScreenActive={isFullScreenActive}
            highlightedEquipments={highlightedEquipments}
          />
        </div>
      ))}
    </div>
  );
});

export default withStyles(styles)(EquipmentTypeList);

EquipmentTypeList.propTypes = {
  classes: PropTypes.object.isRequired,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      equip_type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string,
      list: PropTypes.array.isRequired,
    }),
  ),
  isFullScreenActive: PropTypes.bool,
  highlightedEquipments: PropTypes.objectOf(PropTypes.number),
};

EquipmentTypeList.defaultProps = {
  list: [],
  isFullScreenActive: false,
  highlightedEquipments: {},
};
